// extracted by mini-css-extract-plugin
export var button_ad = "styles-module--button_ad--179a8";
export var colors_controls = "styles-module--colors_controls--6774c";
export var colors_scale = "styles-module--colors_scale--3017e";
export var gradient_result = "styles-module--gradient_result--01d88";
export var heading = "styles-module--heading--f3145";
export var settings = "styles-module--settings--361cd";
export var wrapper = "styles-module--wrapper--90782";
export var wrapper_grid = "styles-module--wrapper_grid--894ff";